import React from "react";

const WORDS = ["Marketing", "Technologia", "Sprzedaż", "Skalowanie", "Dyskrecja", "Wyniki"];

export const Marquee = () => {
  return (
    <section
      className="relative py-12 md:py-16 overflow-hidden bg-graphite border-y border-white/[0.06]"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      {/* soft glow */}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="w-[70%] h-[60%] rounded-full blur-[120px] bg-coral/10" />
      </div>

      <div className="relative pm-marquee pm-marquee-slow items-center gap-8 md:gap-14">
        {[...WORDS, ...WORDS, ...WORDS].map((w, i) => {
          const accent = i % 3 === 1;
          return (
            <span key={i} className="flex items-center gap-8 md:gap-14 shrink-0">
              <span
                className="font-display font-bold tracking-[-0.02em] whitespace-nowrap select-none text-[clamp(30px,5vw,64px)] leading-none"
                style={
                  accent
                    ? {
                        backgroundImage: "linear-gradient(180deg,#ff8aa0 0%,#ff4d67 55%,#d5b578 100%)",
                        WebkitBackgroundClip: "text",
                        backgroundClip: "text",
                        color: "transparent",
                        filter: "drop-shadow(0 0 18px rgba(255,77,103,0.35))",
                      }
                    : {
                        backgroundImage: "linear-gradient(180deg,#ffffff 0%,#c9cad6 45%,#71727f 100%)",
                        WebkitBackgroundClip: "text",
                        backgroundClip: "text",
                        color: "transparent",
                      }
                }
              >
                {w}
              </span>
              <span
                className="w-2.5 h-2.5 rotate-45 shrink-0 bg-coral"
                style={{ boxShadow: "0 0 14px 1px rgba(255,77,103,0.8)" }}
              />
            </span>
          );
        })}
      </div>
    </section>
  );
};
